import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcons';
import { detectIE, isMobileDevice } from '../utilities/common';

import './style/index.css';

const DocumentPreviewModal = props => {
  const {
    documentUrl,
    documentType,
    documentName,
    documentId,
    closeModal,
    handleDownload,
    canDownload,
    fallBackText,
    isTechPage
  } = props;

  const downloadBtnClass = `preview-action ${isTechPage ? 'tech-doc-download-qwf ' : ''}`;
  return (
    <div className="document-preview-container">
      <div className="preview-header">
        <div className="document-name">{documentName}</div>
        <div className="actions">
          {canDownload && (
            <span
              className={`${downloadBtnClass}`}
              onClick={() => handleDownload(documentId, true)}
              role="presentation"
              onKeyUp={() => handleDownload(documentId, true)}
            >
              <CustomIcon size="24" type="download" />
            </span>
          )}
          <span onClick={closeModal} role="presentation" onKeyUp={closeModal}>
            <CustomIcon size="24" type="mdClose" />
          </span>
        </div>
      </div>
      <div className="file-viewer">
        {isMobileDevice() || detectIE() ? (
          <p className="ie-fallback">{fallBackText}</p>
        ) : (
          <iframe src={`${documentUrl}#toolbar=0`} type={documentType} title={documentName} />
        )}
      </div>
    </div>
  );
};

DocumentPreviewModal.propTypes = {
  documentUrl: PropTypes.string.isRequired,
  isTechPage: PropTypes.bool.isRequired,
  documentType: PropTypes.string,
  documentId: PropTypes.string.isRequired,
  documentName: PropTypes.string,
  fallBackText: PropTypes.string,
  canDownload: PropTypes.bool,
  closeModal: PropTypes.func,
  handleDownload: PropTypes.func
};

DocumentPreviewModal.defaultProps = {
  documentName: '',
  canDownload: false,
  documentType: 'pdf',
  fallBackText: '',
  closeModal: () => {},
  handleDownload: () => {}
};

export default DocumentPreviewModal;
